export default {
  init() {


    // let href = $('.link-comprar-ciudad').attr('href');

    // $('.btnEntradasPrincipal').attr('href', href);

    console.log('estamos en la ciudad');
    $('#quitar-mute').click( function (){
      if( $('video').prop('muted', true) )
      {
        $('video').prop('muted', false);
        $('#quitar-mute').css('display','none');
        $('#mute-video').css('display','block');
      }
    });

    $('#mute-video').click( function (){
      $('video').prop('muted', true);
      $('#quitar-mute').css('display','block');
      $('#mute-video').css('display','none');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-ciudad.js